import styled from "styled-components";
import {Project, StyledBaseProps} from "@betrue/shared/interfaces";
import React from "react";
import {ProjectListProps} from "@betrue/ui";
import {MenuItem, Select} from "@mui/material";

export interface ProjectListViewProps extends StyledBaseProps, ProjectListProps {
  projectList: Project[]
  selectedProject: Project,
  onProjectSelected: (id: string) => void
}

export const ProjectListView = styled((props: ProjectListViewProps) => (
  <div className={props.className}>

    <Select
      className={"bt-project-select "}
      onChange={(change) => props.onProjectSelected(change.target.value as string)}
      value={props.selectedProject?.id ? props.selectedProject?.id : ""}
      label="test"
      MenuProps={{disablePortal: true }}
      variant={"outlined"}>
      {props.projectList?.map(p => {
        return (
          <MenuItem key={p.id} value={p.id}>
            {`${p.name}`}
          </MenuItem>
        );
      })}
    </Select>
  </div>
))`
  & {
    .bt-project-select {
      width: 100%;
    }
  }`
